import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";
import { withRouter } from "react-router-dom";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class VehicleBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      studentId: "",
      dialogOpen: false,
      notificationOpen: false,
    };
  }

  handleEdit = (studentId) => {
    this.setState({
      editStatus: true,
      studentId,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: true,
    });
  };

  handleDialogOpen = (vehicleId) => {
    this.setState({
      dialogOpen: true,
      vehicleId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteVehicle = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/vehicles/${this.state.vehicleId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Vehicle deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getVehicles();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteVehicle();
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.route}</TableCell>
        <TableCell align="center">{data.vehicleNumber}</TableCell>
        <TableCell align="center">{data.driver.driverFullName}</TableCell>
        <TableCell align="center">
          {data.assistantDriver.driverFullName}
        </TableCell>
        <TableCell align="center">
          <Tooltip
            title="Info"
            arrow
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(
                `/administration/vehicle/details/${data._id}`
              )
            }
          >
            <InfoIcon />
          </Tooltip>
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(
                `/administration/vehicle/edit/${data._id}`
              )
            }
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteVehicle}
        />
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(VehicleBody)));
